import { createAction } from '@reduxjs/toolkit';

const postEasyPostShipmentClearState = createAction('postEasyPostShipmentClearState');

export default postEasyPostShipmentClearState;
